export const OPEN_LIST_ITEM_POPUP = "OPEN_LIST_ITEM_POPUP"
export const HIDE_LIST_ITEM_POPUP = "HIDE_LIST_ITEM_POPUP"

export const ADD_NEW_LIST = "ADD_NEW_LIST"
export const ADD_NEW_LIST_SUCCESS = "ADD_NEW_LIST_SUCCESS"
export const ADD_NEW_LIST_FAILED = "ADD_NEW_LIST_FAILED"

export const GET_LIST_OF_LISTS = "GET_LIST_OF_LISTS"
export const GET_LIST_OF_LISTS_SUCCESS = "GET_LIST_OF_LISTS_SUCCESS"
export const GET_LIST_OF_LISTS_FAILED = "GET_LIST_OF_LISTS_FAILED"
export const RESET_LIST_OF_LISTS = "RESET_LIST_OF_LISTS"

export const OPEN_COPY_LIST_MODAL = "OPEN_COPY_LIST_MODAL"
export const HIDE_COPY_LIST_MODAL = "HIDE_COPY_LIST_MODAL"

export const GET_EXPERIENCES = "GET_EXPERIENCES"
export const GET_EXPERIENCES_SUCCESS = "GET_EXPERIENCES_SUCCESS"
export const GET_EXPERIENCES_FAILED = "GET_EXPERIENCES_FAILED"

export const GET_EXPERIENCES_LIST = "GET_EXPERIENCES_LIST"
export const GET_EXPERIENCES_LIST_SUCCESS = "GET_EXPERIENCES_LIST_SUCCESS"
export const GET_EXPERIENCES_LIST_FAILED = "GET_EXPERIENCES_LIST_FAILED"

export const GET_LIST_FEATURE = "GET_LIST_FEATURE"
export const GET_LIST_FEATURE_SUCCESS = "GET_LIST_FEATURE_SUCCESS"
export const GET_LIST_FEATURE_FAILED = "GET_LIST_FEATURE_FAILED"
export const RESET_LIST_FEATURE = "RESET_LIST_FEATURE"

export const UPDATE_LIST = "UPDATE_LIST"
export const UPDATE_LIST_SUCCESS = "UPDATE_LIST_SUCCESS"
export const UPDATE_LIST_FAILED = "UPDATE_LIST_FAILED"

export const DELETE_LIST_ITEM = "DELETE_LIST_ITEM"
export const DELETE_LIST_ITEM_SUCCESS = "DELETE_LIST_ITEM_SUCCESS"
export const DELETE_LIST_ITEM_FAILED = "DELETE_LIST_ITEM_FAILED"
export const OPEN_DELETE_LIST_MODAL = "OPEN_DELETE_LIST_MODAL"
export const HIDE_DELETE_LIST_MODAL = "HIDE_DELETE_LIST_MODAL"

export const UPDATE_LIST_FEATURE = "UPDATE_LIST_FEATURE"
export const UPDATE_LIST_FEATURE_SUCCESS = "UPDATE_LIST_FEATURE_SUCCESS"
export const UPDATE_LIST_FEATURE_FAILED = "UPDATE_LIST_FEATURE_FAILED"

export const COPY_LIST = "COPY_LIST"
export const COPY_LIST_SUCCESS = "COPY_LIST_SUCCESS"
export const COPY_LIST_FAILED = "COPY_LIST_FAILED"

export const UPDATE_LIST_ORDER = "UPDATE_LIST_ORDER"
export const UPDATE_LIST_ORDER_SUCCESS = "UPDATE_LIST_ORDER_SUCCESS"
export const UPDATE_LIST_ORDER_FAILED = "UPDATE_LIST_ORDER_FAILED"

export const GET_LIST_ITEM = "GET_LIST_ITEM"
export const GET_LIST_ITEM_SUCCESS = "GET_LIST_ITEM_SUCCESS"
export const GET_LIST_ITEM_FAILED = "GET_LIST_ITEM_FAILED"
export const RESET_LIST_ITEM = "RESET_LIST_ITEM"
export const GET_LIST_ITEM_CLICKS = "GET_LIST_ITEM_CLICKS"
export const GET_LIST_ITEM_CLICKS_SUCCESS = "GET_LIST_ITEM_CLICKS_SUCCESS"
export const GET_LIST_ITEM_CLICKS_FAILED = "GET_LIST_ITEM_CLICKS_FAILED"
export const RESET_LIST_ITEM_CLICKS = "RESET_LIST_ITEM_CLICKS"
